var Mustache = require("mustache");
import Swiper from "swiper";
import swiperA11y from "./utils/swiperA11y";
import breakpointChecker from "./utils/breakpointChecker";
import config from "./utils/config";

(function ($) {
  if ($(".fund--featuredFund").length > 0) {
    window.Sharer.init({
      callbackAPI: `featuredFundCard__slider`,
    });
    let swiper = {};
    const enableSwiper = function (_id) {
      $(`.featuredFundCard__slider_${_id}`).removeClass(
        "featuredFundCard__slider--static",
      );
      let _swiper = new Swiper(`.featuredFundCard__slider_${_id}`, {
        autoplay: false,
        loop: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        pagination: {
          el: `.featuredFundCard__slider_${_id} .swiper-pagination`,
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          320: {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        init: false,
        on: {
          init: function () {
            swiperA11y.toggleAriaHidden(_swiper, false);
          },
        },
      });

      _swiper.init();

      _swiper.on("transitionStart", function () {
        swiperA11y.toggleAriaHidden(_swiper, false);
      });
      swiper[_id] = _swiper;
    };

    function destroySwiper(_id) {
      if (!!swiper[_id]) {
        swiper[_id].destroy(true, true);
      }
      $(`.featuredFundCard__slider_${_id}`).addClass(
        `featuredFundCard__slider--static`,
      );
      $(`.featuredFundCard__slider_${_id} .featuredFundCard__slide`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
      $(`.featuredFundCard__slider_${_id}`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
    }

    try {
      var data = {};
      $.ajax({
        url: config.endpoints.feature_overview,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        // data: JSON.stringify(fund),
        // async: false
      })
        .done(function (_data) {
          var _featureOverview = _data.featureOverview;

          $.each(_featureOverview, function (index, item) {
            if (item.fundList) {
              if (item.fundList.length > 0) {
                $(`.fund--featuredFund`).append(
                  `<div class="container"><div class="featuredFundCard featuredFundCard_${index}"></div></div>`,
                );
                $(`.featuredFundCard_${index}`).append(
                  `<h2 class="featuredFundCard__heading">${item["indicator_" + config.lang]}</h2>`,
                );
                $(`.featuredFundCard_${index}`).append(
                  `<div class="featuredFundCard__slider featuredFundCard__slider_${index} featuredFundCard__slider--static"><div class="swiper-wrapper"></div></div>`,
                );
                $(`.featuredFundCard__slider_${index}`).append(
                  `<div class="featuredFundCard__controls"><div class="swiper-pagination"></div></div>`,
                );

                $.each(item.fundList, function (fundIndex, innerItem) {
                  let product = {
                    Fund_name:
                      config.lang == "en"
                        ? innerItem["Fund_name_eng"]
                        : config.lang == "sc"
                          ? innerItem["Fund_name_zhcn"]
                          : innerItem["Fund_name_zhtw"],
                    Asset_class:
                      config.lang == "en"
                        ? innerItem["Asset_class_Eng"]
                        : config.lang == "sc"
                          ? innerItem["Asset_class_Zhcn"]
                          : innerItem["Asset_class_Zhtw"],
                    image_path: innerItem.image_path,
                    description: innerItem["description_" + config.lang],
                    webLink: innerItem["webLink_" + config.lang],
                  };
                  var template = document.getElementById(
                    "featuredFundCard__template",
                  ).innerHTML;
                  var rendered = Mustache.render(
                    template,
                    product,
                    {},
                    config.customTag,
                  );
                  $(
                    `.featuredFundCard__slider_${index} .swiper-wrapper`,
                  ).append(rendered);
                });
                const BPChecker = new breakpointChecker({
                  mediaQuery: "(min-width:992px)",
                  onMatch: function () {
                    // destroySwiper(index);
                  },
                  onDifferent: function () {
                    // enableSwiper(index)
                  },
                });
              }
            }
          });
        })
        .fail(function (state) {
          // $('#fundCard__slider').text(state)
        });
      // var template = document.getElementById('fundCard__template').innerHTML;
      // var rendered = Mustache.render(template, _funds, {}, config.customTag);
      // document.getElementById('fundCard__slider').innerHTML = rendered;
    } catch (e) {
      console.log(e);
    }
  }
})(hsvmJQuery);
